import { createContext } from 'react';

export interface TranslationData {
  locale: string;
  messages: { [key: string]: string };
}

export const initialContext: TranslationData = {
  locale: 'en',
  messages: {}
};

export default createContext<TranslationData>(initialContext);
